<script>
import { Row, Col, Toast, Popup } from 'vant'
import { AppType } from '../../utils'
import { BanmaAppBridgeHelper } from '../../libs/js-bridge'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-member-accept',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-row': Row,
        'van-col': Col,
        'van-popup': Popup,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            member: {
                organizationName: null,
                roleLabel: null,
                hidePCSide: null,
            },
            showGoPC: null,
            locale: {}
        }
    },

    //--------------------------------------------------
    // component computed
    //--------------------------------------------------
    computed: {
        welcomeTitle() {
            if (this.locale.localeProp) {
                return this.locale.localeProp('welcome-title', {role: this.member.roleLabel})
            }
            return ''
        },
        welcomeOrganization() {
            if (this.locale.localeProp) {
                return this.locale.localeProp('welcome-organization', {organization: this.member.organizationName})
            }
            return ''
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onAppDownloadClick() {
            if (AppType.isInApp() && AppType.isInAndroid()) {
                BanmaAppBridgeHelper.openBrowser('https://a.app.qq.com/o/simple.jsp?pkgname=cn.snsports.banma')
            }
            else {
                window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=cn.snsports.banma'
            }
        },
        onGoPCItemClick() {
            this.showGoPC = true
        },
        onGoPCPopupClick() {
            const url = 'https://saas-v2.snsports.cn'
            this.showGoPC = false
            if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(url)
                Toast(this.locale['copy-succeed'])
            }
            else {
                Toast(this.locale['copy-failed'])
            }
        },
    },
}
</script>

<template>
    <div class="member-accept bg-white">
        <div class="head">
            <div class="welcome-message justify-center vertical-center">
                <div class="inline-block">
                    <div class="symbol-wrapper">
                        <img src="@/assets/org/accept-symbol.png" style="width: 45px; height: 45px;"/>
                    </div>
                </div>
                <div class="inline-block l-outer-margin">
                    <div class="welcome-title">
                        <span>{{ welcomeTitle }}</span>
                    </div>
                    <div class="welcome-org">
                        <span>{{ welcomeOrganization }}</span>
                    </div>
                </div>
            </div>
            <div class="download-area">
                <div class="download-bar">
                    <div v-if="!member.hidePCSide" class="app-download justify-center vertical-center">
                        <div class="download-btn text-center r-wide-margin" @click="onAppDownloadClick">
                            <span class="r-inner-margin"><img src="@/fcl/assets/user/ios-icon-w.svg"/></span>
                            <span class="r-inner-margin"><img src="@/fcl/assets/user/android-icon-w.svg"/></span>
                            <span class="label">{{ locale['app-download'] }}</span>
                        </div>
                        <div class="download-btn text-center" @click="onGoPCItemClick">
                            <span class="r-inner-margin"><img src="@/fcl/assets/user/pc-icon-w.svg"/></span>
                            <span class="label">{{ locale['pc-link'] }}</span>
                        </div>
                    </div>
                    <div v-else class="app-download-only justify-center vertical-center">
                        <div class="download-btn text-center" @click="onAppDownloadClick">
                            <span class="r-inner-margin"><img src="@/fcl/assets/user/ios-icon-w.svg"/></span>
                            <span class="r-inner-margin"><img src="@/fcl/assets/user/android-icon-w.svg"/></span>
                            <span class="label">{{ locale['app-download'] }}</span>
                        </div>
                    </div>
                </div>
                <div class="hint-text">
                    <span v-if="!member.hidePCSide" class="label">{{ locale['download-hint'] }}</span>
                    <span v-else class="label">{{ locale['download-app-hint'] }}</span>
                </div>
            </div>
        </div>
        <div class="body">
            <div class="feature-title text-center">
                <span>{{ locale['download'] }}</span>
                <span class="logo"><img src="@/assets/org/logo-square-icon.svg"/></span>
                <span>{{ locale['download-app-title'] }}</span>
            </div>
            <div class="feature-grid">
                <van-row gutter="10">
                    <van-col span="12">
                        <div class="item-wrapper vertical-center justify-center">
                            <span class="icon"><img src="@/assets/org/feature-item-org.svg"/></span>
                            <span class="label">{{ locale['feature-item-org'] }}</span>
                        </div>
                    </van-col>
                    <van-col span="12">
                        <div class="item-wrapper vertical-center justify-center">
                            <span class="icon"><img src="@/assets/org/feature-item-live.svg"/></span>
                            <span class="label">{{ locale['feature-item-live'] }}</span>
                        </div>
                    </van-col>
                </van-row>
                <van-row gutter="10">
                    <van-col span="12">
                        <div class="item-wrapper vertical-center justify-center">
                            <span class="icon"><img src="@/assets/org/feature-item-fee.svg"/></span>
                            <span class="label">{{ locale['feature-item-fee'] }}</span>
                        </div>
                    </van-col>
                    <van-col span="12">
                        <div class="item-wrapper vertical-center justify-center">
                            <span class="icon"><img src="@/assets/org/feature-item-stats.svg"/></span>
                            <span class="label">{{ locale['feature-item-stats'] }}</span>
                        </div>
                    </van-col>
                </van-row>
                <van-row gutter="10">
                    <van-col span="12">
                        <div class="item-wrapper vertical-center justify-center">
                            <span class="icon"><img src="@/assets/org/feature-item-schedule.svg"/></span>
                            <span class="label">{{ locale['feature-item-schedule'] }}</span>
                        </div>
                    </van-col>
                    <van-col span="12">
                        <div class="item-wrapper vertical-center justify-center">
                            <span class="icon"><img src="@/assets/org/feature-item-insurance.svg"/></span>
                            <span class="label">{{ locale['feature-item-insurance'] }}</span>
                        </div>
                    </van-col>
                </van-row>
            </div>
        </div>
        <div class="unsafe-area-bottom-mask"/>
        <van-popup v-model="showGoPC">
            <div @click="onGoPCPopupClick">
                <img 
                    src="@/fcl/assets/user/go-pc-advanced-edition.png" 
                    style="width: 283px; height: 307px;"
                />
            </div>
        </van-popup>
    </div>
</template>

<style scoped>
.member-accept {
    height: 100vh;
}
.head {
    height: 280px;
    width: 100%;
    background: linear-gradient(180deg, #DBEBFA 0%, #DBEBFA 100%);
}
.welcome-message {
    height: 192px;
}
.download-area {
    height: 80px;
}
.welcome-title span {
    font-family: Source Han Sans;
    font-size: 15px;
    font-weight: bold;
    line-height: normal;
    letter-spacing: normal;
    color: #3D3D3D;
}
.welcome-org span {
    font-family: Source Han Sans;
    font-size: 13px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #999999;
}
.feature-title {
    margin-top: 38px;
}
.feature-title span {
    font-family: Source Han Sans;
    font-size: 15px;
    font-weight: bold;
    line-height: normal;
    letter-spacing: normal;
    color: #666666;
}
.feature-title .logo {
    padding: 2px;
}
.feature-grid {
    margin: 28px 45px;
}
.feature-grid .item-wrapper {
    border-radius: 5px;
    background: #F1F1F1;
    height: 57px;
    margin-bottom: 6px;
}
.feature-grid .item-wrapper .icon {
    margin-right: 4px;
    padding-top: 6px;
}
.feature-grid .item-wrapper .label {
    font-family: Source Han Sans;
    font-size: 15px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #666666;
}
.download-btn {
    width: 139px;
    height: 48px;
    border-radius: 5px;
    background: #3972FF;
    display: inline-block;
}
.app-download-only .download-btn {
    width: 298px;
}
.download-btn .label {
    font-family: Source Han Sans;
    font-size: 16px;
    font-weight: normal;
    line-height: normal;
    color: #FFFFFF;
    line-height: 48px;
}
.hint-text {
    padding: 8px 38px;
}
.hint-text .label {
    font-family: Source Han Sans;
    font-size: 12px;
    font-weight: normal;
    line-height: normal;
    color: #73767A;
    line-height: 16px;
}
</style>